// extracted by mini-css-extract-plugin
module.exports = {"borderedBlock":"AboutUsSection_borderedBlock__8Bg2e","bannerInner":"AboutUsSection_bannerInner__iJ1Ip","banner":"AboutUsSection_banner__rwb_M"};